import React, { useEffect} from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {ListItemText, Tooltip, IconButton} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import ComponentTypeAutoComplete from "../../../shared/ComponentTypeAutoComplete";
import {MySelectInput} from "../../MySelectInput";
import {MyTextInput} from "../../MyTextInput";
import {MyCheckbox} from "../../MyCheckbox";
import {GeometryMapField} from "../../../shared/GeometryMapField";
import {makeStyles} from "@mui/styles";
import styled from "styled-components";
import InfoIcon from '@mui/icons-material/Info';


const useStyles = makeStyles((theme) => ({

    itemText: {
        margin: "10px",
        paddingLeft: "30px",
    },
    ListComp: {
        padding: "30px",
        margin: "10px",
    },
    InputLabel: {
        width: "200px"
    },
    selectbox: {
        width: "100%"
    },
}));

const Label = styled.label`
  left: 26px;
  pointer-events: none;
  position: absolute;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  z-index: 1;
  background-color: #ffffff;
  color: #888888;
  padding-left: 4px;
  padding-right: 4px;
  top: ${(props) => (props.isFloating ? `-2px` : `35%`)};
  font-size: ${(props) => (props.isFloating ? `0.75rem` : `1rem`)};
`;

function DataComponentList({componentSelected, attributeList, treeItemsState, setComponentTypeValue, value, liegenschaftSubFlatList, setRealestateobjectSubValues, realestateobjectSubValue, componentFlatListValues, setParentComponentValue, parentComponentValue, userProject}) {
    const classes = useStyles();

    useEffect(() => {
        if(value && !componentSelected?.componentType) {
            setComponentTypeValue(value);
        }
    },[]);

    const treeFlatList = [];
    if(userProject && userProject.componenttypes?.length > 0) {
        userProject.componenttypes.forEach(item => {
            convert(item)
        });
    } else {
        treeItemsState.forEach(item => {
            convert(item)
        });
    }
    function convert(item) {
        const myItem = {};
        myItem.name = item.name;
        myItem.id = item.objecttype_id;
        myItem.code = item.code;
        myItem.title = item.code + ' - ' + item.name;
        myItem.cafmId = item.cafm_id;
        myItem.globalId = item.global_id;
        myItem.key = item.global_id;
        treeFlatList.push(myItem);
        item.children_objecttypes?.forEach(item2 => {
            convert(item2)
        });
    }

    return (
        <>
            <List>

                {componentSelected.componentType ? (
                    <>
                        <ListItem key="1">
                            <ListItemText key="7">{componentSelected.componentType?.mmsCode} - {componentSelected.componentType?.name}</ListItemText>
                        </ListItem>
                        <ListItem key="2">
                            <InputLabel key="5" className={classes.InputLabel}>Guid</InputLabel>
                            <ListItemText key="6">{componentSelected.guid}</ListItemText>
                        </ListItem>
                    </>
                ) : (
                    <>
                        <ListItem key="3">
                            <ListItemText key="8">Bauteiltyp auswählen</ListItemText>
                        </ListItem>
                        <ListItem key="4">
                            <ComponentTypeAutoComplete
                                key="9"
                                flatList={treeFlatList}
                                setValue={setComponentTypeValue}
                                value={value}
                                label="Bauteiltypen wählen oder Text eingeben"
                            />
                        </ListItem>

                    </>
                )}

                <ListItem key={componentSelected.guid + '-1'}>
                    <MyTextInput
                        key={'mti' + componentSelected.guid + '-1'}
                        margin="dense"
                        name="name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        label="Name"
                        InputLabelProps={{ shrink: true }}
                        required
                    />
                </ListItem>
                <ListItem key={componentSelected.guid + '-2'}>
                    <MyTextInput
                        key={'mti' + componentSelected.guid + '-2'}
                        margin="dense"
                        name="number"
                        type="text"
                        fullWidth
                        variant="outlined"
                        label="Nummer"
                        InputLabelProps={{ shrink: true }}
                    />
                </ListItem>
                <ListItem key={componentSelected.guid + '-3'}>
                    <MyTextInput
                        key={'mti' + componentSelected.guid + '-3'}
                        margin="dense"
                        name="label"
                        type="text"
                        fullWidth
                        variant="outlined"
                        label="Kennzeichen"
                        InputLabelProps={{ shrink: true }}
                    />
                </ListItem>
                <ListItem>
                    <ComponentTypeAutoComplete
                        flatList={liegenschaftSubFlatList}
                        setValue={setRealestateobjectSubValues}
                        value={realestateobjectSubValue}
                        label="Ort (zugehöriges Immobilienobjekt)"
                    />
                    <div style={{width: "11px"}}></div>
                    <ComponentTypeAutoComplete
                        key="9"
                        flatList={componentFlatListValues}
                        setValue={setParentComponentValue}
                        value={parentComponentValue}
                        label="übergeordnetes Bauteil"
                    />
                </ListItem>


                {attributeList && attributeList.sort((a, b) => a.label.localeCompare(b.label)).map((attr, index)=> (

                    <ListItem key={'li' +index}>

                        {attr.enumeratorValues && attr.enumeratorValues.length !==0 ? (
                            <>
                                <Label key={'lab' + attr.id} isFloating={true}>{attr.label}</Label>
                                <MySelectInput
                                    key={attr.key}
                                    margin="dense"
                                    name={attr.name}
                                    label={attr.label}
                                    fullWidth
                                    variant="outlined"
                                    native={true}
                                    displayEmpty={true}
                                    sx={{fontFamily: 'sans-serif', color: '#333'}}
                                    defaultValue={attr.value ? attr.value : ''}
                                >
                                    <option key={'empty' + attr.key} value="" >- Bitte wählen -</option>
                                    {attr.enumeratorValues && attr.enumeratorValues.map((item, index) => {
                                        let itemValue = ''
                                        if(item instanceof Object) {
                                            itemValue = item.text
                                        } else {
                                            itemValue = item;
                                        }

                                        return (
                                            <option key={'m' + index} value={itemValue} >{item.text}</option>
                                        )}
                                    )}

                                </MySelectInput>
                                {(attr.dimension || attr.definition_de || attr.description || attr.example_de) ? (
                                    <Tooltip title={
                                        <>
                                            {attr.dimension && (
                                                <div>{attr.dimension}</div>
                                            )}
                                            {attr.definition_de && (
                                                <div>{attr.definition_de}</div>
                                            )}
                                            {(attr.description && attr.definition_de !== attr.description)&& (
                                                <div>{attr.description}</div>
                                            )}
                                            {attr.example_de && (
                                                <div>{attr.example_de}</div>
                                            )}
                                        </>
                                    } data-html="true" arrow>
                                        <IconButton>
                                            <InfoIcon />
                                        </IconButton>
                                    </Tooltip>
                                ) : null
                                }

                            </>
                        ): (
                            <>
                                {attr.dataType === 'Date' || attr.dataType ==='Time' || attr.data_type === 'Date' || attr.data_type ==='Time' ? (
                                    <>
                                        <MyTextInput
                                            key={'mti' + attr.key}
                                            margin="dense"
                                            name={attr.name}
                                            type="date"
                                            fullWidth
                                            variant="outlined"
                                            label={attr.label}
                                            InputLabelProps={{ shrink: attr.label ? true : false }}
                                        />
                                        {(attr.dimension || attr.definition_de || attr.description || attr.example_de) ? (
                                            <Tooltip title={
                                                <>
                                                    {attr.dimension && (
                                                        <div>{attr.dimension}</div>
                                                    )}
                                                    {attr.definition_de && (
                                                        <div>{attr.definition_de}</div>
                                                    )}
                                                    {(attr.description && attr.definition_de !== attr.description)&& (
                                                        <div>{attr.description}</div>
                                                    )}
                                                    {attr.example_de && (
                                                        <div>{attr.example_de}</div>
                                                    )}
                                                </>
                                            } data-html="true" arrow>
                                                <IconButton>
                                                    <InfoIcon />
                                                </IconButton>
                                            </Tooltip>
                                        ) : null
                                        }
                                    </>
                                ): (
                                    <>
                                        {attr.dataType === 'Real' || attr.dataType ==='Integer' || attr.data_type === 'Real' || attr.data_type ==='Integer'? (
                                            <>
                                                <MyTextInput
                                                    key={'mti' + attr.key}
                                                    margin="dense"
                                                    name={attr.name}
                                                    type="number"
                                                    fullWidth
                                                    variant="outlined"
                                                    label={attr.label + (attr.unit ? ' [' + attr.unit + ']' : '')}
                                                    InputLabelProps={{ shrink: attr.label ? true : false }}
                                                />
                                                {(attr.dimension || attr.definition_de || attr.description || attr.example_de) ? (
                                                    <Tooltip title={
                                                        <>
                                                            {attr.dimension && (
                                                                <div>{attr.dimension}</div>
                                                            )}
                                                            {attr.definition_de && (
                                                                <div>{attr.definition_de}</div>
                                                            )}
                                                            {(attr.description && attr.definition_de !== attr.description)&& (
                                                                <div>{attr.description}</div>
                                                            )}
                                                            {attr.example_de && (
                                                                <div>{attr.example_de}</div>
                                                            )}
                                                        </>
                                                    } data-html="true" arrow>
                                                        <IconButton>
                                                            <InfoIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : null
                                                }
                                            </>
                                        ) : (
                                            <>
                                                {attr.dataType === 'Boolean' || attr.data_type === 'Boolean' ? (
                                                    <>
                                                        <MyCheckbox
                                                            name={attr.name}
                                                        >{attr.label}</MyCheckbox>

                                                    </>
                                                ) : (
                                                    <>
                                                        {attr.reference_field === 'realestateobject' && (attr.attributeType ==='IfcExternalReference' || attr.type ==='IfcExternalReference') ? (
                                                            <>
                                                                <ComponentTypeAutoComplete
                                                                    flatList={liegenschaftSubFlatList}
                                                                    setValue={setRealestateobjectSubValues}
                                                                    value={realestateobjectSubValue}
                                                                    label="Ort (zugehöriges Immobilienobjekt)"
                                                                />
                                                            </>
                                                        ): (
                                                            <>
                                                                {attr.reference_field === 'component' && (attr.attributeType ==='IfcExternalReference' || attr.type ==='IfcExternalReference') ? (
                                                                    <>
                                                                        <ComponentTypeAutoComplete
                                                                            key="9"
                                                                            flatList={componentFlatListValues}
                                                                            setValue={setParentComponentValue}
                                                                            value={parentComponentValue}
                                                                            label="übergeordnetes Bauteil"
                                                                        />
                                                                    </>
                                                                ): (
                                                                    <>
                                                                        <MyTextInput
                                                                            key={'mti' + attr.key}
                                                                            margin="dense"
                                                                            name={attr.name}
                                                                            type="text"
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            label={attr.label + (attr.unit ? ' [' + attr.unit + ']' : '')}
                                                                            InputLabelProps={{ shrink: attr.label ? true : false }}
                                                                        />
                                                                        {(attr.dimension || attr.definition_de || attr.description || attr.example_de) ? (
                                                                            <Tooltip title={
                                                                                <>
                                                                                {attr.dimension && (
                                                                                    <div>{attr.dimension}</div>
                                                                                )}
                                                                                {attr.definition_de && (
                                                                                    <div>{attr.definition_de}</div>
                                                                                )}
                                                                                {(attr.description && attr.definition_de !== attr.description)&& (
                                                                                    <div>{attr.description}</div>
                                                                                )}
                                                                                {attr.example_de && (
                                                                                    <div>{attr.example_de}</div>
                                                                                )}
                                                                                </>
                                                                            } data-html="true" arrow>
                                                                            <IconButton>
                                                                                <InfoIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                            ) : null
                                                                        }
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </ListItem>

                ))}

                <ListItem key={componentSelected.guid + '-4'}>
                    <GeometryMapField name="geom" />
                </ListItem>

                {componentSelected && componentSelected.id ? (
                    <ListItem key="2">
                        <InputLabel key="10" className={classes.InputLabel}>deaktiviert</InputLabel>
                        <ListItemText key="11">{componentSelected.deactivated ? 'ja': 'nein'}</ListItemText>
                    </ListItem>
                ): null}

            </List>
        </>
    )
}

export default DataComponentList;
